import { AppInfoLoader } from '@src/services/AppInfoLoader';
import { ServiceClient } from '@src/services/coralservices/ServiceClient';
import _ from 'lodash';
import IhmESLService from 'IhmESLService-coral-javascript-clients/store-specific-jquery-client.js';
import { StoreFamily } from '@src/types/StoreFamily';

const client = new ServiceClient('IhmESL', IhmESLService);

export class ESLServiceClient {
    public static getDataForEsl(storeId, eslId) {
        if (storeId === StoreFamily.StoreFamily.KASPIAN) {
            return this.sendRequest<void>(
                {
                    operation: 'GetEslData',
                    data: {
                        eslId,
                    },
                },
                storeId,
            );
        } else {
            return this.sendRequest<void>(
                {
                    operation: 'GetDataForESL',
                    data: {
                        eslId,
                    },
                },
                storeId,
            );
        }
    }

    public static sendRequest<T>(input: { [key: string]: any }, storeId: string): Promise<T> {
        const dataToSend: { [key: string]: any } = _.cloneDeep(input.data);
        dataToSend.storeId = storeId; // Include the storeId in the input for store isolation routing
        return client.sendRequest(
            {
                operation: input.operation,
                data: dataToSend,
            },
            storeId,
        );
    }
}
